import request from '../utils/request';

//会刊信息获取
export function getInfo() {
  return request({
    url: '/frontExhibitor/proceedingInfo/proceedingView',
    method: 'get',
  });
}

export function commitProceedingInfo(data){
  return request({
    url: '/frontExhibitor/proceedingInfo/commitProceedingInfo',
    method: 'post',
    data: data,
  });
}